type LogRocketModule = typeof import('logrocket');

let logRocketPromise: Promise<LogRocketModule> | null = null;
let isLogRocketInitialized = false;

async function loadLogRocket(): Promise<LogRocketModule> {
  logRocketPromise ??= import('logrocket').then((module) => {
    const maybeDefaultModule = module as unknown as { default?: LogRocketModule };

    return maybeDefaultModule.default ?? module;
  }).catch((error: unknown) => {
    logRocketPromise = null;
    throw error;
  });

  return logRocketPromise;
}

export function useLogRocket() {
  const { $mixpanel, $logger } = useNuxtApp();
  const { LOGROCKET_PROJECT_ID } = useRuntimeConfig().public;
  const store = useKegelAnalyticStore();

  async function initLogRocket(): Promise<void> {
    if (!import.meta.client || !LOGROCKET_PROJECT_ID || typeof LOGROCKET_PROJECT_ID !== 'string') {
      return;
    }

    try {
      const LogRocket = await loadLogRocket();

      if (!isLogRocketInitialized) {
        isLogRocketInitialized = true;

        LogRocket.init(LOGROCKET_PROJECT_ID, {
          dom: {
            inputSanitizer: true,
          },
        });
        LogRocket.getSessionURL((url: string) => {
          $mixpanel.people.set({ 'LogRocket URL': url });
        });
      }

      store.isLogRocketEnabled = true;
      LogRocket.identify(store.userUuid, { email: store.userEmail });
    } catch (error: unknown) {
      isLogRocketInitialized = false;
      $logger.note({
        category: 'logRocket',
        message: 'initialisation failed',
        level: 'warning',
        cause: error,
      });
    }
  }

  return {
    initLogRocket,
  };
}
